import { css } from '@emotion/core';
import { injectGlobal } from 'emotion';
import FontFaceObserver from 'fontfaceobserver';
import 'regenerator-runtime/runtime';

export interface FontParams {
  family: string;
  style: string;
  url: string;
  weights: Object;
  fallback: any;
}

export function loadFont(props: FontParams, weight: number) {
  const wrapperClassName = `${props.family.toLowerCase()}_${props.style}_${weight}`;

  injectGlobal`
    @font-face {
      font-family: '${props.family}';
      src: url('${props.url}/${weight}/${props.weights[weight].eot}');
      src: url('${props.url}/${weight}/${props.weights[weight].eot_ie}') format('embedded-opentype'),
           url('${props.url}/${weight}/${props.weights[weight].woff2}') format('woff2'),
           url('${props.url}/${weight}/${props.weights[weight].woff}') format('woff'),
           url('${props.url}/${weight}/${props.weights[weight].ttf}') format('truetype');
      font-weight: ${weight};
      font-style: ${props.style};
    }
  `;

  injectGlobal`
    @supports (font: -apple-system-body) {
      html {
        font: -apple-system-body;
      }
    }
  `;

  if (typeof document !== 'undefined') {
    (async (): Promise<any> => {
      new FontFaceObserver(props.family, {
        weight: weight,
        style: props.style,
      })
        .load()
        .then(
          function () {
            document.body.classList.add(wrapperClassName);
          },
          function (e) {
            console.warn(`[loadFont] failed to load font: ${e.message}`);
          }
        );
    })();
  }

  return css`
    font-family: ${props.fallback};
    font-weight: ${weight};
    font-style: ${props.style};

    .${wrapperClassName} & {
      font-family: ${props.family}, ${props.fallback};
    }
  `;
}
